import { UsernameObject } from '@shared/types/dashboard-data';
import { icons } from 'constants/assets';
import { FC } from 'react';

export const UserNameDetails: FC<{ username: UsernameObject }> = ({ username }) => {
  const { name, discriminator } = username;

  return (
    <div
      className="objektiv-mk3-lg flex items-center gap-2 rounded-[8px] bg-[#0E122C] px-3 py-1 text-[#ECEAED]"
    >
      <div className="text-[#FDF3E8]">
        <img src={icons.accountIcon} alt="account" width={12} height={14} />
      </div>
      <span className="text-nowrap">
        {name}
        {' '}
        #
        {discriminator}
      </span>
    </div>
  );
};
